module.exports = __webpack_public_path__ + "static/media/Muli-Bold.5631e4f0.eot";